import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import SendIcon from '@material-ui/icons/Send';
import clsx from 'clsx';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';

let googleTransliterate = require('google-input-tool');

//import TextField from '@material-ui/core/TextField';
//import { NeuTextInput } from "neumorphism-react";
//import { NeuButton } from "neumorphism-react";
//import { NeuDiv } from "neumorphism-react";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
//import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
// import Visibility from '@material-ui/icons/Visibility';
// import VisibilityOff from '@material-ui/icons/VisibilityOff';
//import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
//import IconButton from '@material-ui/core/IconButton';
//import Input from '@material-ui/core/Input';
//import FilledInput from '@material-ui/core/FilledInput';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: "100%",
      margin: theme.spacing(1)
    },
    appbar: {
        top: 'auto',
        bottom: 0,
        backgroundColor: grey[100],
        borderColor: grey[700],
    },
    textField: {
        width: "100%",
    },
    box:{
        top: 'auto',
        bottom: 0,
        borderColor: grey[700],
    },
    send:{
        marginTop: "5px",
        color:"#ff693a"
    },
    msgText:{
       // borderRadius: "50px !important",
      //  backgroundColor: "#FFF !important",
        //border: "1px solid #162b75",
        height:"45px",
        //color:"#162b75"
    },
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        //backgroundColor: "#F0F0F0",
        borderRadius: "0",
        borderBottom: "5px solid #ff693a"
    },

    btn: {
        margin: theme.spacing(1),
        background: "#f26522",
        color: "#fff",
    },

    modalHeader:{
        textAlign: 'center', 
        color:'#fff',
        padding: "11px",
        background: "#f26522",
        borderTopLeftRadius: "7px",
        borderTopRightRadius: "7px",
    },

     modal: {
        position: 'fixed',
        transform: "translate(-50%, -50%)",
        width: "97%", //Old value was 400px
        backgroundColor: theme.palette.background.paper,
        borderBottom: "10px solid #f26522",
        boxShadow: theme.shadows[5],
        borderRadius: "10px",
        color: '#162b75',
        opacity: "0.95",
        backgroundImage: "radial-gradient(#f265227d 0.35px, #fff 0.35px)",
        backgroundSize: "7px 7px",
        //border: "2px solid #334"
        //border: '2px solid #f26522',
        //padding: theme.spacing(2, 4, 3),
        //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        //border: '2px solid #000',
        
        //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        //color: 'white',
        //padding: theme.spacing(2, 4, 3),
    },
}));

const ChatInput = (props) => {
    const classes = useStyles();
    const [ isSendDisabled, setIsSendDisabled ] = useState(true);
    const [ chatInputText, setChatInputText ] = useState ("");
    const [ chatLanguage, setChatLanguage ] = useState ("en");
    const [open, setOpen] = React.useState(false); //For Modal

    // const handleModalOpen = () => {
    //     setOpen(true);
    // };

    const handleModalClose = () => {
        setOpen(false);
    }; 
    //const google = window.google = window.google ? window.google : {};
    //const google = window.google;
    let inputLanguage = 'ne-t-i0-und';
    let maxResult = 8;
    let request = new XMLHttpRequest();

    const onInputChange = (event) => {
        // console.log(event.target.value);
        if(event.target.value !== ""){
            setIsSendDisabled(false);
        }
        else {
            setIsSendDisabled(true);
        }
        setChatInputText(event.target.value);
    }

    const onKeyDownHandler = (event) => {
        if(chatLanguage === "hi" && event.key === " "){
            googleTransliterate(request, chatInputText, inputLanguage, maxResult)
            .then(function(response) {
                //console.log('Transliterated Text: ', response[0][0]);
                setChatInputText(response[0][0]+" ");
            });
        }
        if (event.key === 'Enter') {
            onSendClicked();
        }
    }

    const onSendClicked = () => {
        // console.log(chatInputText);
        // console.log("SKY : "+document.getElementById("transliterateTextarea").value)
        if(chatInputText !== ""){
            props.chatInputHandler(chatInputText);
            setChatInputText("");
            setIsSendDisabled(true);
        }
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        console.log(event.target.dataset.lang);
        setChatLanguage(event.target.dataset.lang);
        if(event.target.dataset.lang === "hi"){
            setOpen(true);
            document.getElementById("txtChat").placeholder = "अपना प्रश्न बताएं";
        }

        if(event.target.dataset.lang === "en"){
            document.getElementById("txtChat").placeholder = "Type your query";
        }

        setChatInputText("");
        setAnchorEl(null);
    };

    





    return (
        <Box className={classes.box}>
            <AppBar position="fixed" className={classes.appbar}>
            {/* <NeuDiv width="100%" height="100%" radius={0} distance={1} color={grey[200]}> */}
            <Paper className={classes.paper}>
                <Box width="100%" >
                <Grid container spacing={1} alignItems="stretch">
                
                    <Grid item xs={8} sm={8} md={10} lg={10} xl={10} >                         
                        <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
                            <OutlinedInput                                
                                className={classes.msgText}
                                placeholder="Type your query"
                                value={chatInputText}
                                onChange={onInputChange} 
                                onKeyDown={onKeyDownHandler} 
                                id="txtChat"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={2} sm={2} md={1} lg={1} xl={1} justify="flex-end">
                        <KeyboardOutlinedIcon id="sel-chat-lang" fontSize="large" 
                            className={classes.send} aria-controls="lang-menu" aria-haspopup="true" onClick={handleClick}
                        />   
            
                        <Menu
                            id="lang-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >                            
                            <MenuItem onClick={handleClose} data-lang="en">English</MenuItem>
                            <MenuItem onClick={handleClose} data-lang="hi">Hindi</MenuItem>
                        </Menu>



                        <Modal
                            disableEscapeKeyDown
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="rating-modal-title"
                            aria-describedby="rating-modal-description"
                            >
                            <div style={{top:'30%', left:'50%'}} className={classes.modal}>
                                <h4 className={classes.modalHeader} id="rating-modal-title">अस्वीकरण</h4>
                                <h6 style={{textAlign: 'center', color:'#162b75'}} >
                                    पाठ आपकी भाषा में अनुवादित किया जाएगा और हो सकता है कि पुरी तरह सटीक ना हो। 
                                    अधिक स्पष्टता के लिए, कृपया हमारे फोनबैंकिंग प्रतिनिधि से संपर्क करें या अपनी निकटतम शाखा पर जाएं।
                                </h6>
                                <p id="rating-modal-description">
                                    <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                                        <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" onClick={handleModalClose} className={classes.btn}>पुष्टि करें</Button>                                  
                                    </Box>
                                    
                                </p>                              
                            </div>
                            </Modal>

                    </Grid>

                    <Grid item xs={2} sm={2} md={1} lg={1} xl={1} justify="flex-end">
                        <SendIcon fontSize="large" className={classes.send} 
                        disabled={isSendDisabled} onClick={onSendClicked}/>                        
                    </Grid>
                   
                </Grid>
                </Box>
            </Paper>
            {/* </NeuDiv> */}
            </AppBar>
        </Box>
    )
    
};

export default ChatInput;